import { render, staticRenderFns } from "./pagePart2.vue?vue&type=template&id=578e216d&scoped=true"
import script from "./pagePart2.vue?vue&type=script&lang=js"
export * from "./pagePart2.vue?vue&type=script&lang=js"
import style0 from "./pagePart2.vue?vue&type=style&index=0&id=578e216d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e216d",
  null
  
)

export default component.exports